import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { EduFileInterface, EduFileTypeEnum } from '../../+models/EduFile.interface';
import { CustomFeedbackHandlersInterface, FeedbackTriggeringAction } from '../effect-feedback';

export enum EduFilesActionTypes {
  LoadEduFiles = '[EduFiles] Load EduFiles',
  LoadEduFilesForArtifacts = '[EduFiles] Load EduFiles for Artifacts',
  EduFilesLoaded = '[EduFiles] EduFiles Loaded',
  EduFilesLoadedForArtifacts = '[EduFiles] EduFiles Loaded for Artifacts',
  EduFilesLoadError = '[EduFiles] Load Error',
  EduFilesForArtifactsLoadError = '[EduFiles] Load for Artifacts Error',
  AddEduFiles = '[EduFiles] Add EduFiles',
  StartAddEduFile = '[EduFile] Start Add EduFile',
  AddEduFile = '[EduFiles] Add EduFile',
  UpdateEduFile = '[EduFiles] Update EduFile',
  DeleteEduFile = '[EduFiles] Delete EduFile',
  UpsertEduFile = '[EduFiles] Upsert EduFile',
  AddEduFilesForEduContent = '[EduFiles] Add EduFiles For Edu Content',
}

export class AddEduFilesForEduContent implements Action {
  readonly type = EduFilesActionTypes.AddEduFilesForEduContent;

  constructor(public payload: { eduContentId: number; eduFiles: EduFileInterface[] }) {}
}

export class LoadEduFiles implements Action {
  readonly type = EduFilesActionTypes.LoadEduFiles;

  constructor(public payload: { force?: boolean; userId: number } = { userId: null }) {}
}

export class LoadEduFilesForArtifacts implements Action {
  readonly type = EduFilesActionTypes.LoadEduFilesForArtifacts;

  constructor(public payload: { force?: boolean; } = {}) {}
}

export class EduFilesLoaded implements Action {
  readonly type = EduFilesActionTypes.EduFilesLoaded;

  constructor(public payload: { eduFiles: EduFileInterface[] }) {}
}

export class EduFilesLoadedForArtifacts implements Action {
  readonly type = EduFilesActionTypes.EduFilesLoadedForArtifacts;

  constructor(public payload: { eduFiles: EduFileInterface[] }) {}
}

export class EduFilesLoadError implements Action {
  readonly type = EduFilesActionTypes.EduFilesLoadError;
  constructor(public payload: any) {}
}

export class EduFilesForArtifactsLoadError implements Action {
  readonly type = EduFilesActionTypes.EduFilesForArtifactsLoadError;
  constructor(public payload: any) {}
}

export class StartAddEduFile implements Action, FeedbackTriggeringAction {
  readonly type = EduFilesActionTypes.StartAddEduFile;

  constructor(
    public payload: {
      userId: number;
      eduContentId: number;
      file: File;
      type: EduFileTypeEnum;
      customFeedbackHandlers?: CustomFeedbackHandlersInterface;
    }
  ) {}
}

export class AddEduFile implements Action {
  readonly type = EduFilesActionTypes.AddEduFile;

  constructor(public payload: { eduFile: EduFileInterface }) {}
}

export class AddEduFiles implements Action {
  readonly type = EduFilesActionTypes.AddEduFiles;

  constructor(public payload: { eduFiles: EduFileInterface[] }) {}
}

export class UpdateEduFile implements FeedbackTriggeringAction {
  readonly type = EduFilesActionTypes.UpdateEduFile;

  constructor(
    public payload: {
      eduFile: Update<EduFileInterface>;
      customFeedbackHandlers?: CustomFeedbackHandlersInterface;
    }
  ) {}
}

export class DeleteEduFile implements Action {
  readonly type = EduFilesActionTypes.DeleteEduFile;

  constructor(public payload: { id: number }) {}
}

export class UpsertEduFile implements Action {
  readonly type = EduFilesActionTypes.UpsertEduFile;

  constructor(public payload: { eduFile: EduFileInterface }) {}
}

export type EduFilesActions =
  | LoadEduFiles
  | LoadEduFilesForArtifacts
  | StartAddEduFile
  | AddEduFiles
  | AddEduFile
  | UpdateEduFile
  | DeleteEduFile
  | UpsertEduFile
  | EduFilesLoaded
  | EduFilesLoadedForArtifacts
  | EduFilesLoadError
  | EduFilesForArtifactsLoadError
  | AddEduFilesForEduContent;
